import { __ } from '@wordpress/i18n'

import React from 'react'
import PropTypes from 'prop-types'
import {
  Teaser,
  Image,
  Content,
  HoverContent,
  Title,
  Excerpt,
  DateBadge,
  TopBadge,
  Link,
  ReadMore,
} from './custom.styled'
import placeholder from '../../../images/placeholder.jpg'

const NewsEventsTeaser = ({ post, isSlider = false, isEditor = false }) => {
  return (
    post && (
      <Teaser isSlider={isSlider} isEvent={post.isEvent}>
        {post.isEvent && <TopBadge>{post.eventDate}</TopBadge>}
        <Image>
          <img
            src={post.image.url || placeholder}
            alt={post.image.alt || post.image.title}
          />
        </Image>
        <Content>
          <DateBadge>
            {post.isEvent ? (
              <span>{__('Event', 'dhsv_theme')}</span>
            ) : (
              <span>{post.date}</span>
            )}
          </DateBadge>
          <Title>{post.title}</Title>
        </Content>
        {post.text && (
          <HoverContent>
            <DateBadge>
              {post.isEvent ? (
                <span>{__('Event', 'dhsv_theme')}</span>
              ) : (
                <span>{post.date}</span>
              )}
            </DateBadge>
            <Excerpt dangerouslySetInnerHTML={{ __html: post.text }} />
          </HoverContent>
        )}
        {!isEditor && <Link href={post.link.url}></Link>}
        <ReadMore>
          {__('Read More', 'dhsv_theme')}
          <i className="las la-arrow-circle-right"></i>
        </ReadMore>
      </Teaser>
    )
  )
}

NewsEventsTeaser.propTypes = {
  post: PropTypes.object,
  isSlider: PropTypes.bool,
  isEditor: PropTypes.bool,
}

export default NewsEventsTeaser
